import Home from './Home.vue'
import About from './About.vue'
import Contact from './Contact.vue'
import Projects from './Projects.vue'
import Resume from './Resume.vue'
import Docs from './Docs.vue'

export {
    Home,
    About,
    Contact,
    Projects,
    Resume,
    Docs
}


// WEBPACK FOOTER //
// ./src/components/views/index.js